import { IField } from "../interfaces/inputs/IField";

export const SalesAttachmentFields: IField[] = [
  { name: "attachment", type: "file", label: "Attachment", size: {lg: 12}, position: 12 }
].sort((a: IField, b: IField) => a.position - b.position);